// @ts-check
export function help() {
  console.log(
    `Having trouble using Squatch.js? Go to https://docs.referralsaasquatch.com/developer/ for tutorials, references and error codes.`
  );
}
